const AdminTypeEnum = {
  ADMIN: 0,
  COLLABORATOR: 1,
  PARTNER: 2,
};

const AdminTypeLabel = new Map([
  [AdminTypeEnum.ADMIN, 'Administrador'],
  [AdminTypeEnum.COLLABORATOR, 'Colaborador'],
  [AdminTypeEnum.PARTNER, 'Parceiro'],
]);

export { AdminTypeEnum, AdminTypeLabel };
